"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticTextsWithBrand = void 0;
var react_1 = __importDefault(require("react"));
var enums_1 = require("../shared/enums");
exports.staticTextsWithBrand = {
    errorMessage: (_a = {},
        _a[enums_1.BrandEnum.CALVERT] = (react_1.default.createElement(react_1.default.Fragment, null,
            "If the problem continues, please call technical support at",
            ' ',
            react_1.default.createElement("a", { href: "tel://877-760-0289" }, "877-760-0289"),
            " Monday through Friday from 7 a.m. to 5 p.m. (CT). You can also chat with us through our",
            ' ',
            react_1.default.createElement("a", { href: "https://calverthomeschool.com/support/contact-us", target: "_blank", rel: "noreferrer" }, "Support Page"))),
        _a[enums_1.BrandEnum.MONARCH] = (react_1.default.createElement(react_1.default.Fragment, null,
            "If the problem continues, please call technical support at",
            ' ',
            react_1.default.createElement("a", { href: "tel://800-622-3070" }, "800-622-3070"),
            " Monday through Friday from 7 a.m. to 5 p.m. (CT). You can also chat with us through our",
            ' ',
            react_1.default.createElement("a", { href: "https://www.aop.com/support", target: "_blank", rel: "noreferrer" }, "Support Page"))),
        _a),
};
